
export const toE164 = (phoneNumber) => {
  const e164 = /^\+?[1-9]\d{1,14}$/;
  if (e164.test(phoneNumber)) {
    return phoneNumber;
  } else {
    const numbersOnly = phoneNumber.replace(/\D/g, '');
    const removeFirstZero = numbersOnly && numbersOnly[0] === '0' ? numbersOnly.substring(1) : numbersOnly;
    return `+82${removeFirstZero}`;
  }
}

export const fromE164 = (e164Number) => {
  const e164 = /^\+?[1-9]\d{1,14}$/;
  if (!e164.test(e164Number)) {
    return e164Number;
  } else {
    const krCountryCodeRemoved = e164Number.substring(3);
    const firstZeroAdded = `0${krCountryCodeRemoved}`;
    return phoneFomatter(firstZeroAdded);
  }
}

function phoneFomatter(num, type) {
  var formatNum = '';
  if (num.length === 11) {
    if (type === 0) {
      formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3');
    } else {
      formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  } else if (num.length === 8) {
    formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2');
  } else {
    if (num.indexOf('02') === 0) {
      if (type === 0) {
        formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3');
      } else {
        formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
      }
    } else {
      if (type === 0) {
        formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3');
      } else {
        formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      }
    }
  }
  return formatNum;
}